<script setup>
const backend = useBackend()

const { data: links } = useAsyncData(async () => {
  const linksData = await backend.getSeoLinks();
  return linksData.data || [];
});

const openedSections = ref({})
</script>

<template>
  <div class="bg-gray-50">
    <Container>
      <div
        v-for="(subcategories, category) in links"
        :key="category"
        class="mb-6"
      >
        <div class="text-xl text-coolGray-800 mb-2">
          {{ category }}
        </div>

        <div
          v-for="(items, subcategory) in subcategories"
          :key="subcategory"
          class="border-b py-4"
        >
          <div
            class="flex justify-between cursor-pointer"
            @click="openedSections[`${category}-${subcategory}`] = !openedSections[`${category}-${subcategory}`]"
          >
            <div class="text-coolGray-700 text-base">
              {{ subcategory }}
            </div>
            <IconChevronDown
              class="transition-transform duration-300 cursor-pointer"
              :class="{ 'rotate-180': openedSections[`${category}-${subcategory}`] }"
            />
          </div>

          <div v-if="openedSections[`${category}-${subcategory}`]" class="mt-3">
            <!-- Pierwszy element wyróżniony -->
            <div class="text-sm text-azure mb-2">
              <a :href="items[0].url" class="hover:underline text-sm text-azure font-extralight">
                {{ items[0].label }}
              </a>
            </div>
            <!-- Reszta elementów w siatce -->
            <div class="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2 text-sm text-azure font-extralight">
              <div v-for="item in items.slice(1)" :key="item.label">
                <a :href="item.url" class="hover:underline">
                  {{ item.label }}
                </a>
              </div>
            </div>
          </div>


        </div>
      </div>
    </Container>
  </div>
</template>
